import React, { useState } from 'react';
import { Alert, Input, Modal, Typography } from 'antd';
import { AzureOnboardingListItem } from '../../../../services/azure/azureOnboarding/azureOnboarding.model';

const { Text } = Typography;

interface ResetTenantModalProps {
  row: AzureOnboardingListItem;
  // Resolves true when the reset succeeded (the parent then unmounts this modal).
  onConfirm: () => Promise<boolean>;
  onClose: () => void;
}

const ResetTenantModal: React.FC<ResetTenantModalProps> = ({ row, onConfirm, onClose }) => {
  const [typed, setTyped] = useState('');
  const [saving, setSaving] = useState(false);
  // bu_name is nullable in the list; fall back to a fixed word so the guard still works.
  const confirmWord = row.bu_name || 'RESET';
  const n = row.scopes.total;

  const handleOk = async () => {
    setSaving(true);
    if (!(await onConfirm())) setSaving(false);
  };

  return (
    <Modal
      wrapClassName="custom-modal"
      title="Reset Azure tenant?"
      centered
      visible
      onCancel={onClose}
      onOk={handleOk}
      okText="Reset tenant"
      okButtonProps={{ danger: true, disabled: typed.trim() !== confirmWord, loading: saving }}
      cancelText="Cancel"
      width={560}
    >
      <Alert
        type="error"
        showIcon
        message={
          <>
            This <strong>deletes all {n} scope row{n === 1 ? '' : 's'}</strong> for{' '}
            <em>
              {row.company_name ?? '–'} / {row.bu_name ?? '–'}
            </em>
            .
          </>
        }
        style={{ marginBottom: 12 }}
      />
      <ul style={{ paddingLeft: 20 }}>
        <li>It unbinds the client&apos;s Azure tenant and stops data collection.</li>
        <li>The client link can then be consented by a different Azure tenant.</li>
        <li>Existing collected data isn&apos;t deleted.</li>
        <li>This can&apos;t be undone. Re-onboarding starts from scratch.</li>
      </ul>
      <div className="form-group m-0">
        Type <Text code>{confirmWord}</Text> to confirm
        <Input
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          aria-label="Confirm reset"
          autoComplete="off"
        />
      </div>
    </Modal>
  );
};

export default ResetTenantModal;
